import { Component, Input, OnInit, inject } from "@angular/core";
import { ICardMetadata, KeyValue } from "@tylertech/tyler-api-types";
import { Utilities } from "@tylertech/shared-module";
import { ODataFilterFactoryService } from "@tylertech/odata-module";
import { RepositoryFormData } from "../../../interfaces";
import { CachedCodeLookupService, MetadataService } from "../../../services";

@Component({
    selector: "card-list-item-header",
    templateUrl: "./cardListItemHeader.tmpl.html",
    standalone: false
})
export class CardListItemHeaderComponent implements OnInit
{
    private $cachedCodeLookupService = inject(CachedCodeLookupService);
    private readonly $odataFilterFactory = inject(ODataFilterFactoryService);
    private $metadataService = inject(MetadataService);

    @Input()
    cardMetadata: ICardMetadata;

    @Input()
    model: any;

    @Input()
    datacontroller: RepositoryFormData;

    @Input()
    hasBody: boolean;

    subtitles: KeyValue[];

    ngOnInit()
    {
        if (!this.cardMetadata.SubtitleMetaData)
            return;
        this.loadSubtitles();
    }

    loadSubtitles(): void
    {
        const self = this;
        const loaders: Promise<any>[] = [];
        this.subtitles = [];
        const properties = this.$metadataService
            .FlattenProperties(this.cardMetadata.SubtitleMetaData, this.model.$$Parent, this.model)
            .filter(
                x =>
                    !this.$metadataService.IsHiddenProperty(x.property) &&
                    !this.$metadataService.EvaluateBoolean(x.property.HiddenProperty, x.parent, x.model)
            )
            .sort((a, b) => a.property.RenderPosition - b.property.RenderPosition);
        properties.forEach((p, i) =>
        {
            const value = p.model[p.name];
            if (!Utilities.IsNullOrUndefined(value))
            {
                if (p.property.Lookup)
                {
                    let fieldValue = "";
                    const builder = this.$odataFilterFactory.createBuilder();
                    builder.filterEQ("Key", value);
                    loaders.push(
                        this.$cachedCodeLookupService.Get(p.property.Lookup, builder.build())
                        .then(x =>
                        {
                            if (x && x.length > 0)
                                fieldValue = x[0].Value;
                            self.subtitles.push({Key: i, Value: fieldValue});
                        })
                    );
                }
                else
                    self.subtitles.push({Key: i, Value: this.$metadataService.getFormattedValue(p)});
            }
        });

        Promise.all(loaders).then(() =>
        {
            self.subtitles = self.subtitles.sort((a, b) => a.Key - b.Key);
        });
    }
}
